import React from 'react'

const EmojiIcon = () => {
  return (
    // eslint-disable-next-line
    <svg height="25px" width="25px"  fill="#e53935" x="0px" y="0px" viewBox="0 0 985 985" stroke="2">
      <g><path d="M500,10C229.4,10,10,229.4,10,500s219.4,490,490,490s490-219.4,490-490S770.6,10,500,10z M500,946.8c-246.7,0-446.8-200-446.8-446.8c0-246.7,200-446.8,446.8-446.8c246.7,0,446.8,200,446.8,446.8C946.8,746.7,746.7,946.8,500,946.8z"/><path d="M232.3,363.5c0,44.2,35.8,80.1,80.1,80.1s80.1-35.8,80.1-80.1c0-44.2-35.8-80.1-80.1-80.1S232.3,319.2,232.3,363.5z"/><path d="M607.5,363.5c0,44.2,35.8,80.1,80.1,80.1c44.2,0,80.1-35.8,80.1-80.1c0-44.2-35.8-80.1-80.1-80.1C643.4,283.4,607.5,319.2,607.5,363.5z"/><path d="M767.7,567.8c0,147.8-119.8,267.7-267.7,267.7S232.3,715.7,232.3,567.8H767.7z"/></g>
    </svg>
  )
}

export default EmojiIcon
